"use client";

import { cn } from "@heroui/theme";
import { ReactNode } from "react";
import { Breadcrumb, BreadcrumbItem } from "./Breadcrumb";
import { PageHeader, PageHeaderProps } from "./PageHeader";

interface SimpleLayoutProps {
  children: ReactNode;
  pageHeaderProps?: PageHeaderProps;
  breadcrumbItems?: BreadcrumbItem[];
  className?: string;
}

export default function PageLayout({
  children,
  pageHeaderProps,
  breadcrumbItems,
  className,
}: SimpleLayoutProps) {
  return (
    <>
      {/* Breadcrumb - centered at the top of the page */}
      {breadcrumbItems && <Breadcrumb items={breadcrumbItems} />}

      <section
        className={cn(
          "flex max-w-6xl mx-auto flex-col items-center px-4",
          className,
        )}
      >
        {pageHeaderProps && <PageHeader {...pageHeaderProps} />}
        {children}
      </section>
    </>
  );
}
